import React from "react"
import { TextField, Dialog, FlatButton, SelectField, MenuItem, Toggle } from "material-ui"
import strings from "../../localization/strings"
import ChipSelect from "../common/ChipSelect"
import FinddDatePicker from "../common/FinddDatePicker"
import autobind from "class-autobind"
import * as permissionHelper from "../../helpers/permissionHelper"
import moment from "moment"
import * as utils from "../../helpers/utils"
import * as timeHelper from "../../helpers/timeHelper"
import HolidayTemplatesChip from "./holidayTemplatesChip/HolidayTemplatesChip"
import { EOvertimeRuleType, IPayType, IPayGroup, EPayCalendarTypes, EDayOfWeek, IChipSelectItem, IHolidayPaygroupInstance, IOvertimeRule, ICaliforniaOvertimeRule, IOTPolicy, EOTType } from "../../models"
import AccountStore from "../../stores/AccountStore"
import { blueGrey500 } from "material-ui/styles/colors"
import * as api from "../../api"
import * as holidayHelper from "../../helpers/holidayHelper"
import SimpleTimeEditor from "../common/SimpleTimeEditor"
import AppStateStore from "../../stores/AppStateStore"
import CustomOvertimeRule from "./overtimeRules/CustomOvertimeRule"
import HierarchyJobTimezoneStr from "../common/HierarchyJobTimezoneStr"

interface IProps {
	open: boolean
	editablePayGroup: IPayGroup
	enablePayroll: boolean
	payTypes: IPayType[]
	payGroups: IPayGroup[]
	daysOfWeek: string[]
	canChangePaygroupCalendarSettings: boolean
	otPolicies: IOTPolicy[]
	onRequestClose(): void
	handlerPayGroupSave(add: boolean, payGroup: IPayGroup): void
}
interface IState {
	name: string
	nameError: string
	maximumPunchSetLength: number
	maximumPunchSetLengthError: string
	payPeriodStartDay: EDayOfWeek
	defaultPayTypeId: string
	linkedPayTypeIds: string[]
	allDataForChipSelect: IChipSelectItem[],
	linkedPayTypeError: string
	payCalendarType: EPayCalendarTypes
	payCalendarStartDate: Date | string
	payCalendarStartDateError: string
	payCalendarMonthlyPayDay1: number
	payCalendarMonthlyPayDay1Error: string
	payCalendarMonthlyPayDay2: number
	payCalendarMonthlyPayDay2Error: string
	defaultPayTypeIdError: string
	holidays: IHolidayPaygroupInstance[]
	errorHolidays: string
	payPeriodDayStartTime24Hour: number
	splitPunchAtDayStart: boolean
	overtimeRules: IOvertimeRule[]
	overtimeRulesError: string
	otPolicyId: string
	otPolicyIdError: string
}

export default class AddPayGroupDialog extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)
		this.state = {
			name: props.editablePayGroup ? props.editablePayGroup.Name : "",
			nameError: "",
			maximumPunchSetLength:
				props.editablePayGroup && props.editablePayGroup.PaySettings && props.editablePayGroup.PaySettings.MaximumPunchSetLength
					? props.editablePayGroup.PaySettings.MaximumPunchSetLength
					: 12,
			maximumPunchSetLengthError: "",
			payPeriodStartDay:
				props.editablePayGroup && props.editablePayGroup.PaySettings && props.editablePayGroup.PaySettings.PayPeriodStartDay !== null
					? props.editablePayGroup.PaySettings.PayPeriodStartDay
					: 1,
			defaultPayTypeId: props.editablePayGroup && props.editablePayGroup.DefaultPayTypeId ? props.editablePayGroup.DefaultPayTypeId : null,
			linkedPayTypeIds: props.editablePayGroup && props.editablePayGroup.LinkedPayTypeIds ? props.editablePayGroup.LinkedPayTypeIds : [],
			allDataForChipSelect: [],
			linkedPayTypeError: "",
			//---- payCalendarType 0=weekly, 1=bi-weekly, 2=monthly,  3=semi-monthly ----
			//---- default is weekly ----
			payCalendarType: props.editablePayGroup && props.editablePayGroup.PaySettings ? props.editablePayGroup.PaySettings.PayCalendarType : 0,
			//---- Used to calculate pay period date for bi-weekly pay calendar types ----
			payCalendarStartDate:
				props.editablePayGroup && props.editablePayGroup.PaySettings && props.editablePayGroup.PaySettings.PayCalendarType === 1
					? timeHelper.keepConvertUTCToLocal(props.editablePayGroup.PaySettings.PayCalendarStartDate)
					: moment().format(),
			payCalendarStartDateError: "",
			//---- For Monthly pay calendar, only use PayDay1 to set which day is pay period starting. ----
			payCalendarMonthlyPayDay1:
				props.editablePayGroup && props.editablePayGroup.PaySettings && (props.editablePayGroup.PaySettings.PayCalendarType === 2 || props.editablePayGroup.PaySettings.PayCalendarType === 3)
					? props.editablePayGroup.PaySettings.PayCalendarMonthlyPayDay1
					: 1,
			payCalendarMonthlyPayDay1Error: "",
			//---- For semi-monthly pay calendar, we use both PayDay1 and PayDay2 to create 2 pay periods per month. ----
			payCalendarMonthlyPayDay2:
				props.editablePayGroup && props.editablePayGroup.PaySettings && props.editablePayGroup.PaySettings.PayCalendarType === 3
					? props.editablePayGroup.PaySettings.PayCalendarMonthlyPayDay2
					: 16,
			payCalendarMonthlyPayDay2Error: "",
			defaultPayTypeIdError: "",
			holidays: props.editablePayGroup && props.editablePayGroup.Holidays ? props.editablePayGroup.Holidays : [],
			errorHolidays: "",
			payPeriodDayStartTime24Hour: props.editablePayGroup ? props.editablePayGroup.PaySettings.PayPeriodDayStartTime24Hour : 0,
			splitPunchAtDayStart: props.editablePayGroup ? props.editablePayGroup.PaySettings.SplitPunchAtDayStart : false,
			overtimeRules: props.editablePayGroup && props.editablePayGroup.PaySettings.OvertimeSettings && props.editablePayGroup.PaySettings.OvertimeSettings.OvertimeRules ?
				props.editablePayGroup.PaySettings.OvertimeSettings.OvertimeRules : [],
			overtimeRulesError: "",
			otPolicyId: props.editablePayGroup ? props.editablePayGroup.OTPolicyId : null,
			otPolicyIdError: null
		}
		autobind(this)
	}

	componentDidMount() {
		const allDataForChipSelect = []
		this.props.payTypes.forEach(payType => {
			allDataForChipSelect.push({ Id: payType.Id, Name: payType.Name })
		})
		this.setState({ allDataForChipSelect })
	}

	checkValidate() {
		let isValidate = true
		const {
			name,
			maximumPunchSetLength,
			defaultPayTypeId,
			linkedPayTypeIds,
			payPeriodStartDay,
			payCalendarType,
			payCalendarStartDate,
			payCalendarMonthlyPayDay1,
			payCalendarMonthlyPayDay2
		} = this.state

		if (!name.trim()) {
			this.setState({ nameError: strings.This_field_is_required })
			isValidate = false
		}
		else {
			if (this.props.payGroups
				.filter(i => this.props.editablePayGroup ? i.Id !== this.props.editablePayGroup.Id : true)
				.find(i => !i.Deleted && i.Name === name.trim())
			) {
				this.setState({ nameError: strings.The_name_must_be_unique })
				isValidate = false
			}
			else {
				this.setState({ nameError: "" })
			}
		}

		//---- maximumPunchSetLength check ----
		if (maximumPunchSetLength < 1 || maximumPunchSetLength > 24) {
			this.setState({ maximumPunchSetLengthError: strings.This_field_requires_a_number_between_1_and_24 })
			isValidate = false
		}

		//---- payCalendar check ----
		if (payCalendarType === 1) {
			if (payCalendarStartDate === null) {
				this.setState({ payCalendarStartDateError: strings.This_field_is_required })
				isValidate = false
			} else if (moment(payCalendarStartDate).day() !== payPeriodStartDay) {
				this.setState({ payCalendarStartDateError: strings.Pay_Calendar_Start_Date_and_Pay_Period_Start_Day_match })
				isValidate = false
			} else {
				this.setState({ payCalendarStartDateError: "" })
			}
		} else if (payCalendarType === 2) {
			if (payCalendarMonthlyPayDay1 < 1 || payCalendarMonthlyPayDay1 > 28) {
				this.setState({ payCalendarMonthlyPayDay1Error: strings.This_field_requires_an_integer_between_1_and_28 })
				isValidate = false
			}
		} else if (payCalendarType === 3) {
			if (payCalendarMonthlyPayDay1 < 1 || payCalendarMonthlyPayDay1 > 15) {
				this.setState({ payCalendarMonthlyPayDay1Error: strings.Input_valid_integer })
				isValidate = false
			}
			if (payCalendarMonthlyPayDay2 < 16 || payCalendarMonthlyPayDay2 > 28) {
				this.setState({ payCalendarMonthlyPayDay2Error: strings.Input_valid_integer })
				isValidate = false
			}
		}

		this.setState({
			defaultPayTypeIdError: defaultPayTypeId ? "" : strings.This_field_is_required
		})

		//---- paygroup must have at leat one paytyp ----
		if (linkedPayTypeIds.length === 0) {
			this.setState({ linkedPayTypeError: strings.Require_at_least_one_PayType })
			isValidate = false
		} else {
			this.setState({ linkedPayTypeError: "" })
		}

		if (this.state.maximumPunchSetLength) {
			const errorHoursPerDayHoliday = this.state.holidays.find(holiday => AccountStore.getCurrentAccount().HolidayTemplates.find(item => item.Id === holiday.HolidayTemplateId).HoursPerDay > this.state.maximumPunchSetLength)
			const errorPayTypeHoliday = this.state.holidays.find(holiday => !this.state.linkedPayTypeIds.includes(holiday.PayTypeId))
			const duplicatedDateHoliday = holidayHelper.checkDuplicatedDateForPayGroup(this.state.holidays)
			if (errorHoursPerDayHoliday) {
				const errorHolidayName = AccountStore.getCurrentAccount().HolidayTemplates.find(item => item.Id === errorHoursPerDayHoliday.HolidayTemplateId).Name
				this.setState({ errorHolidays: strings.formatString(strings.The_HoursPerDay_of_holiday_is_more_than_the_MaximumPunchSetLength, errorHolidayName) as string })
				isValidate = false
			}
			else if (errorPayTypeHoliday) {
				const errorPayTypeHolidayName = AccountStore.getCurrentAccount().HolidayTemplates.find(item => item.Id === errorPayTypeHoliday.HolidayTemplateId).Name
				this.setState({ errorHolidays: strings.formatString(strings.The_PayType_of_holiday_is_invalid, errorPayTypeHolidayName) as string })
				isValidate = false
			}
			else if (duplicatedDateHoliday) {
				this.setState({ errorHolidays: strings.Duplicated_date_exist_for_pay_group })
				isValidate = false
			}
			else {
				this.setState({ errorHolidays: "" })
			}
		}
		else {
			this.setState({ errorHolidays: "" })
		}

		if (AccountStore.getEnableOTPolicy()) {
			if (!this.state.otPolicyId) {
				this.setState({ otPolicyIdError: strings.This_field_is_required })
				isValidate = false
			}
			else if (AccountStore.getCurrentAccount().OTPolicies.find(i => i.Id === this.state.otPolicyId).Type === EOTType.Bi_Weekly && payCalendarType !== EPayCalendarTypes.Biweekly) {
				this.setState({ otPolicyIdError: strings.Cannot_choose_Bi_Weekly_OT_policy })
				isValidate = false
			}
			else {
				this.setState({ otPolicyIdError: null })
			}
		}
		else {
			if (this.state.payCalendarType !== EPayCalendarTypes.Biweekly && this.state.overtimeRules.find(i => i.Type === EOvertimeRuleType.Bi_Weekly)) {
				this.setState({ overtimeRulesError: strings.Bi_Weekly_rule_should_be_not_exist })
				isValidate = false
			}
			else {
				this.setState({ overtimeRulesError: "" })
			}
		}

		return isValidate
	}

	handleRequestSave() {
		if (!this.checkValidate()) return
		const payGroup: IPayGroup = {
			Id: this.props.editablePayGroup ? this.props.editablePayGroup.Id : utils.guid(),
			Name: this.state.name.trim(),
			DefaultPayTypeId: this.state.defaultPayTypeId,
			LinkedPayTypeIds: this.state.linkedPayTypeIds,
			Holidays: this.state.holidays,
			Deleted: false,
			PaySettings: {
				MaximumPunchSetLength: this.state.maximumPunchSetLength,
				PayPeriodStartDay: this.state.payPeriodStartDay,
				PayCalendarType: this.state.payCalendarType,
				PayCalendarStartDate: this.state.payCalendarType === 1 ? moment(this.state.payCalendarStartDate).utc(true).format() : null,
				PayCalendarMonthlyPayDay1: this.state.payCalendarType === 2 || this.state.payCalendarType === 3 ? this.state.payCalendarMonthlyPayDay1 : null,
				PayCalendarMonthlyPayDay2: this.state.payCalendarType === 3 ? this.state.payCalendarMonthlyPayDay2 : null,
				PayPeriodDayStartTime24Hour: this.state.payPeriodDayStartTime24Hour,
				SplitPunchAtDayStart: this.state.splitPunchAtDayStart,
				OvertimeSettings: !AccountStore.getEnableOTPolicy() && this.state.overtimeRules && this.state.overtimeRules.length > 0 ? { OvertimeRules: this.state.overtimeRules } : null
			},
			OTPolicyId: AccountStore.getEnableOTPolicy() ? this.state.otPolicyId : null
		}
		this.props.handlerPayGroupSave(this.props.editablePayGroup ? false : true, payGroup)
	}

	handleChangeMaximumPunchSetLength(e, value) {
		if (utils.validateInteger(value)) {
			this.setState({
				maximumPunchSetLength: value,
				maximumPunchSetLengthError: ""
			}, () => this.checkValidate())
		}
	}

	handleChangePayPeriodStartDay(e, value) {
		(this.props.editablePayGroup === null || this.props.canChangePaygroupCalendarSettings) ?
			this.changePayPeriodStartDay(value) :
			permissionHelper.isGlobalAdmin() ?
				AppStateStore.setConfirmDialogContent({
					title: strings.Change_Pay_Period_Start_Day,
					content: strings.Change_Pay_Period_Start_Day_as_GlobalAdmin,
					confirm: () => this.changePayPeriodStartDay(value)
				}) :
				AppStateStore.setAlertDialogContent({
					title: strings.Cannot_Change_Pay_Period_Start_Day,
					content: strings.Cannot_Change_Pay_Period_Start_Day_Contact_Findd
				})
	}

	changePayPeriodStartDay(value) {
		this.setState({ payPeriodStartDay: value }, () => this.checkValidate())
	}

	handleChangeDefaultPayType(event, key, payload) {
		const linkedPayTypeIds = this.state.linkedPayTypeIds.slice()
		if (linkedPayTypeIds.indexOf(payload) > -1) {
			this.setState({ defaultPayTypeId: payload }, () => this.checkValidate())
		} else {
			linkedPayTypeIds.push(payload)
			this.setState({
				defaultPayTypeId: payload,
				linkedPayTypeIds
			}, () => this.checkValidate())
		}
	}

	handleChangePayCalendarType(event, key, payload) {
		(this.props.editablePayGroup === null || this.props.canChangePaygroupCalendarSettings) ?
			this.changePayCalendarType(payload) :
			permissionHelper.isGlobalAdmin() ?
				AppStateStore.setConfirmDialogContent({
					title: strings.Change_Pay_Calendar,
					content: strings.Change_Pay_Calendar_as_GlobalAdmin,
					confirm: () => this.changePayCalendarType(payload)
				}) :
				AppStateStore.setAlertDialogContent({
					title: strings.Cannot_Change_Pay_Calendar,
					content: strings.Cannot_Change_Pay_Calendar_Contact_Findd
				})
	}

	changePayCalendarType(value) {
		if (this.state.payCalendarType !== value) {
			this.setState({
				payCalendarStartDate: moment().format(),
				payCalendarStartDateError: "",
				payCalendarMonthlyPayDay1: 1,
				payCalendarMonthlyPayDay1Error: "",
				payCalendarMonthlyPayDay2: 16,
				payCalendarMonthlyPayDay2Error: ""
			})
		}
		this.setState({ payCalendarType: value }, () => this.checkValidate())
	}

	handleBiWeeklyStartDate(e, date) {
		(this.props.editablePayGroup === null || this.props.canChangePaygroupCalendarSettings) ?
			this.changeBiWeeklyStartDate(date) :
			permissionHelper.isGlobalAdmin() ?
				AppStateStore.setConfirmDialogContent({
					title: strings.Change_Pay_Calendar_Setting,
					content: strings.Change_Pay_Calendar_Setting_as_GlobalAdmin,
					confirm: () => this.changeBiWeeklyStartDate(date)
				}) :
				AppStateStore.setAlertDialogContent({
					title: strings.Cannot_Change_Pay_Calendar_Setting,
					content: strings.Cannot_Change_Pay_Calendar_Setting_Contact_Findd
				})
	}

	changeBiWeeklyStartDate(date) {
		this.setState({ payCalendarStartDate: date }, () => this.checkValidate())
	}

	handleChangePayCalendarMonthlyPayDay1(event, value) {
		if (!utils.validateInteger(value)) return
		(this.props.editablePayGroup === null || this.props.canChangePaygroupCalendarSettings) ?
			this.changePayCalendarMonthlyPayDay1(value) :
			permissionHelper.isGlobalAdmin() ?
				AppStateStore.setConfirmDialogContent({
					title: strings.Change_Pay_Calendar_Setting,
					content: strings.Change_Pay_Calendar_Setting_as_GlobalAdmin,
					confirm: () => this.changePayCalendarMonthlyPayDay1(value)
				}) :
				AppStateStore.setAlertDialogContent({
					title: strings.Cannot_Change_Pay_Calendar_Setting,
					content: strings.Cannot_Change_Pay_Calendar_Setting_Contact_Findd
				})
	}

	changePayCalendarMonthlyPayDay1(value) {
		this.setState({
			payCalendarMonthlyPayDay1: value,
			payCalendarMonthlyPayDay1Error: ""
		}, () => this.checkValidate())
	}

	handleChangePayCalendarMonthlyPayDay2(event, value) {
		if (!utils.validateInteger(value)) return
		(this.props.editablePayGroup === null || this.props.canChangePaygroupCalendarSettings) ?
			this.changePayCalendarMonthlyPayDay2(value) :
			permissionHelper.isGlobalAdmin() ?
				AppStateStore.setConfirmDialogContent({
					title: strings.Change_Pay_Calendar_Setting,
					content: strings.Change_Pay_Calendar_Setting_as_GlobalAdmin,
					confirm: () => this.changePayCalendarMonthlyPayDay2(value)
				}) :
				AppStateStore.setAlertDialogContent({
					title: strings.Cannot_Change_Pay_Calendar_Setting,
					content: strings.Cannot_Change_Pay_Calendar_Setting_Contact_Findd
				})
	}

	changePayCalendarMonthlyPayDay2(value) {
		this.setState({
			payCalendarMonthlyPayDay2: value,
			payCalendarMonthlyPayDay2Error: ""
		}, () => this.checkValidate())
	}

	addLinkedPayTypes(obj) {
		if (!obj) return
		const linkedPayTypeIds = this.state.linkedPayTypeIds
		linkedPayTypeIds.push(obj.Id)
		this.setState({ linkedPayTypeIds }, () => this.checkValidate())
	}

	removeLinkedPayTypes(obj) {
		this.state.defaultPayTypeId === obj.Id ?
			AppStateStore.setProgressSnackbarContent(strings.This_Pay_Type_is_used_as_a_default_Pay_Type_Cannot_remove_it) :
			this.props.editablePayGroup ?
				api.checkCanUnlinkPayTypeFromPayGroup(AccountStore.getCurrentAccount().Id, this.props.editablePayGroup.Id, obj.Id).then(res =>
					res.data ?
						this.removeLinkedPayType(obj.Id) :
						AppStateStore.setProgressSnackbarContent(strings.This_Pay_Type_is_used_Cannot_remove_it)
				) :
				this.removeLinkedPayType(obj.Id)
	}

	removeLinkedPayType(unlinkPayTypeId) {
		const linkedPayTypeIds = this.state.linkedPayTypeIds
		const indexOf = linkedPayTypeIds.indexOf(unlinkPayTypeId)
		if (indexOf > -1) {
			linkedPayTypeIds.splice(indexOf, 1)
			this.setState({ linkedPayTypeIds }, () => this.checkValidate())
		}
	}

	render() {
		const linkedDataForChipSelect = []
		this.state.linkedPayTypeIds.forEach((payTypeId) => {
			const linkedPayType = this.props.payTypes.find(payType => payType.Id === payTypeId)
			linkedDataForChipSelect.push({
				Id: linkedPayType.Id,
				Name: linkedPayType.Name
			})
		})
		return (
			<Dialog
				open={this.props.open}
				title={this.props.editablePayGroup ? `${strings.Edit_Pay_Group} - ${this.state.name}` : strings.New_Pay_Group}
				titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
				actions={[
					<FlatButton data-intercom-target={"menu-AccountSettings-PayConfiguration-PayGroupTab-Btn-CloseAddPayGroupDialog"} key="cancel" label={strings.CANCEL} secondary onTouchTap={this.props.onRequestClose} />,
					<FlatButton data-intercom-target={"menu-AccountSettings-PayConfiguration-PayGroupTab-Btn-SavePayGroup"} key="save" label={strings.SAVE} primary onTouchTap={this.handleRequestSave} />
				]}
				autoScrollBodyContent
			>
				<hr />
				<div style={{ paddingLeft: 15, paddingRight: 15 }}>
					<TextField
						data-intercom-target={"menu-AccountSettings-PayConfiguration-PayGroupTab-Add-Entry-Name"}
						floatingLabelText={strings.Name}
						value={this.state.name}
						style={{ width: "95%" }}
						onChange={(e, value) => this.setState({ name: value }, () =>
							this.checkValidate()
						)}
						errorText={this.state.nameError}
						errorStyle={{ position: "absolute", bottom: -12 }}
					/>
					<TextField
						data-intercom-target={"menu-AccountSettings-PayConfiguration-PayGroupTab-Add-Entry-MaxPunchSetLengthHours"}
						floatingLabelText={strings.Max_PunchSet_Length_hours}
						value={this.state.maximumPunchSetLength}
						onChange={this.handleChangeMaximumPunchSetLength}
						errorText={this.state.maximumPunchSetLengthError}
						errorStyle={{ position: "absolute", bottom: -12 }}
					/>
					<div style={{ display: "flex" }}>
						<div data-intercom-target={"menu-AccountSettings-PayConfiguration-PayGroupTab-Add-Select-PayPeriodStartDay"}>
							<SelectField
								floatingLabelText={strings.Pay_Period_Start_Day}
								value={this.state.payPeriodStartDay}
								onChange={this.handleChangePayPeriodStartDay}
								disabled={this.props.editablePayGroup != null && !this.props.canChangePaygroupCalendarSettings}
							>
								{this.props.daysOfWeek.map((day, key) =>
									<MenuItem key={key} value={key} primaryText={day} />
								)}
							</SelectField>
						</div>
						<div style={{ marginLeft: 20, display: "flex", alignItems: "baseline" }}>
							<i className="fa fa-clock-o" style={{ marginRight: 10 }} />
							<div style={{ width: 110 }}>
								<SimpleTimeEditor
									label={strings.Workday_Start_Time}
									simpleTime={{ Hour: this.state.payPeriodDayStartTime24Hour, Minute: 0 }}
									readonly={!permissionHelper.isGlobalAdmin()}
									handleChange={simpleTime => this.setState({ payPeriodDayStartTime24Hour: simpleTime.Hour })}
								/>
							</div>
							<div>
								<span style={{ fontSize: 14 }}>
									{strings.Timezone}:&nbsp;
									<HierarchyJobTimezoneStr
										hierarchyId={null}
										jobId={null}
									/>
								</span>
							</div>
						</div>
					</div>
					{AccountStore.getPunchSplitEnabled() &&
						<Toggle
							data-intercom-target={"menu-AccountSettings-PayConfiguration-PayGroupTab-Add-Toggle-SplitPunchesByDayBoundary"}
							label={strings.Split_Punches_by_Day_Boundary}
							toggled={this.state.splitPunchAtDayStart}
							onToggle={(e, value) => this.setState({ splitPunchAtDayStart: value })}
							style={{ maxWidth: 275, marginTop: 20 }}
							labelStyle={{ fontSize: 15 }}
						/>
					}
					{this.props.enablePayroll &&
						<div style={{ display: "flex" }}>
							<div data-intercom-target={"menu-AccountSettings-PayConfiguration-PayGroupTab-Add-Select-PayCalendar"}>
								<SelectField
									floatingLabelText={strings.Pay_Calendar}
									value={this.state.payCalendarType}
									onChange={this.handleChangePayCalendarType}
								>
									<MenuItem value={0} primaryText={strings.Weekly} />
									<MenuItem value={1} primaryText={strings.Bi_Weekly} />
									<MenuItem value={2} primaryText={strings.Monthly} />
									<MenuItem value={3} primaryText={strings.Semi_Monthly} />
								</SelectField>
							</div>
							<div style={{ float: "left", marginLeft: 35 }}>
								{this.state.payCalendarType === 1 &&
									<FinddDatePicker
										data-intercom-target={"menu-AccountSettings-PayConfiguration-PayGroupTab-Add-Select-PayCalendarStartDate"}
										floatingLabelText={strings.Pay_Calendar_Start_Date}
										formatDate={date => moment(date).format("dddd  MMMM DD, YYYY")}
										onChange={this.handleBiWeeklyStartDate}
										value={moment(this.state.payCalendarStartDate).toDate()}
										errorText={this.state.payCalendarStartDateError}
										cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
										firstDayOfWeek={0}
									/>
								}
								{this.state.payCalendarType === 2 &&
									<TextField
										data-intercom-target={"menu-AccountSettings-PayConfiguration-PayGroupTab-Add-Entry-PayCalendarStartDay"}
										floatingLabelText={strings.Pay_Calendar_Start_Day}
										value={this.state.payCalendarMonthlyPayDay1}
										onChange={this.handleChangePayCalendarMonthlyPayDay1}
										errorText={this.state.payCalendarMonthlyPayDay1Error}
										errorStyle={{ position: "absolute", bottom: -12 }}
									/>
								}
								{this.state.payCalendarType === 3 && [
									<TextField
										data-intercom-target={"menu-AccountSettings-PayConfiguration-PayGroupTab-Add-Entry-PayCalendarDay1"}
										key="day1"
										style={{ width: 180 }}
										floatingLabelText={strings.Pay_Calendar_Day1}
										value={this.state.payCalendarMonthlyPayDay1}
										onChange={this.handleChangePayCalendarMonthlyPayDay1}
										errorText={this.state.payCalendarMonthlyPayDay1Error}
										errorStyle={{ position: "absolute", bottom: -12 }}
									/>,
									<TextField
										data-intercom-target={"menu-AccountSettings-PayConfiguration-PayGroupTab-Add-Entry-PayCalendarDay2"}
										key="day2"
										style={{ width: 190, marginLeft: 10 }}
										floatingLabelText={strings.Pay_Calendar_Day2}
										value={this.state.payCalendarMonthlyPayDay2}
										onChange={this.handleChangePayCalendarMonthlyPayDay2}
										errorText={this.state.payCalendarMonthlyPayDay2Error}
										errorStyle={{ position: "absolute", bottom: -12 }}
									/>
								]}
							</div>
						</div>
					}
					<div data-intercom-target={"menu-AccountSettings-PayConfiguration-PayGroupTab-Add-Select-DefaultPayType"}>
						<SelectField
							floatingLabelText={strings.Default_Pay_Type}
							value={this.state.defaultPayTypeId}
							onChange={this.handleChangeDefaultPayType}
							errorText={this.state.defaultPayTypeIdError}
							errorStyle={{ position: "absolute", top: 70 }}
						>
							{this.props.payTypes.map((payType, key) =>
								<MenuItem key={key} value={payType.Id} primaryText={payType.Name} />
							)}
						</SelectField>
					</div>
					<div style={{ marginTop: 15 }}>
						<ChipSelect
							title={strings.Pay_Types}
							titleStyle={{ color: "rgba(0, 0, 0, 0.3)", fontSize: 13 }}
							allData={this.state.allDataForChipSelect}
							linkedData={linkedDataForChipSelect}
							chipStyle={{ marginTop: 10, marginRight: 5, height: 35 }}
							addButtonStyle={{ height: 33, marginTop: 2, display: "inline-block" }}
							labelTextForSelect={strings.Select_Pay_Type}
							handleAddOne={this.addLinkedPayTypes}
							handleDeleteOne={this.removeLinkedPayTypes}
							errorText={this.state.linkedPayTypeError}
						/>
					</div>
					{AccountStore.getCurrentAccountSettings().FeatureSettings.EnableAccrualsTimeoff &&
						AccountStore.getCurrentAccount().HolidayTemplates &&
						AccountStore.getCurrentAccount().HolidayTemplates.length > 0 &&
						<div style={{ marginTop: 25 }}>
							<HolidayTemplatesChip
								title={strings.Holidays}
								titleStyle={{ color: "rgba(0, 0, 0, 0.3)", fontSize: 13 }}
								chipStyle={{ marginTop: 10, marginRight: 5, height: 35 }}
								addButtonStyle={{ height: 40, marginTop: 2, display: "inline-block" }}
								holidays={this.state.holidays}
								handleChange={holidays => this.setState({ holidays }, () => this.checkValidate())}
								error={this.state.errorHolidays}
							/>
						</div>
					}
					<div style={{ marginTop: 25 }}>
						{AccountStore.getEnableOTPolicy() ?
							<SelectField
								floatingLabelText={strings.OT_Policy}
								value={this.state.otPolicyId}
								onChange={(event, key, otPolicyId) => this.setState({ otPolicyId }, () => this.checkValidate())}
								errorText={this.state.otPolicyIdError}
							>
								{this.props.otPolicies.map(i =>
									<MenuItem key={i.Id} value={i.Id} primaryText={i.Name} />
								)}
							</SelectField> :
							<CustomOvertimeRule
								otType={this.state.payCalendarType === EPayCalendarTypes.Biweekly ? EOTType.Bi_Weekly : EOTType.Weekly}
								error={this.state.overtimeRulesError}
								overtimeRules={this.state.overtimeRules}
								handleChange={overtimeRules => this.setState({ overtimeRules }, () => this.checkValidate())}
							/>
						}
					</div>
				</div>
			</Dialog>
		)
	}
}
